import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
const SessionTimeout: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    window.localStorage.removeItem("businessUnitId");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("antiforgery");
    window.localStorage.removeItem("userName");
  }, []);

  const handleRelogin = (e: React.MouseEvent) => {
    e.preventDefault();
    loginWithRedirect({
      appState: { targetUrl: "/" },
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: "2rem",
          marginBottom: "1rem",
          color: "var(--aggrid-text-color)",
        }}
      >
        Session Expired
      </h1>
      <p
        style={{
          textAlign: "center",
          fontSize: "1rem",
          color: "var(--aggrid-text-color)",
        }}
      >
        The session has ended. Please close this window and re-login.
      </p>
    </div>
  );
};

export default SessionTimeout;
